import { SvgIcon, SvgIconProps } from "@mui/material";

interface TicketDualIconProps extends SvgIconProps {
  fillColor?: string; // Optional prop for fill color
  strokeColor?: string; // Optional prop for stroke color
}

export const TicketDualIcon = ({
  fillColor = "#B7BDFB", // Default fill color if not provided
  strokeColor = "currentColor", // Default stroke color if not provided
  ...props
}: TicketDualIconProps) => (
  <SvgIcon {...props}>
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
      <path
        fill={fillColor} // Using the fillColor prop here
        fill-rule="evenodd"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.2"
        d="M22 6.5a2 2 0 0 0-2-2h-2a.601.601 0 0 0-.554.441 1.879 1.879 0 0 1-3.653 0 .601.601 0 0 0-.554-.441H4a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h9.239a.601.601 0 0 0 .554-.44 1.879 1.879 0 0 1 3.653-.001c.07.252.293.43.554.441h2a2 2 0 0 0 2-2v-11Z"
        clip-rule="evenodd"
      />
      <path
        stroke={strokeColor}
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.2"
        d="M15.5 15.25v-.5M15.5 12.25v-.5M15.5 9.25v-.5"
      />
    </svg>
  </SvgIcon>
);
